<select [name]="name" [attr.disabled]="readOnly ? '' : null" [required]="mandatory" [(ngModel)]="value" class="form-control " (change)="handleChange()">
  <option value=""></option>
  <option *ngFor="let upcomingWeekendDisplay of upcomingWeekendsDisplay" [value]="upcomingWeekendDisplay.value">{{ upcomingWeekendDisplay.value }}</option>
</select>
